import React, {Component} from 'react';

import Dygraph from 'dygraphs';
import * as _ from 'lodash';

import './LineChart.css';

const doubleClickZoomOutPlugin = {
    activate: function(g) {
        // Save the initial y-axis range for later.
        const initialValueRange = g.getOption('valueRange');
        return {
            dblclick: e => {
                e.dygraph.updateOptions({
                    dateWindow: null,  // zoom all the way out
                    valueRange: initialValueRange  // zoom to a specific y-axis range.
                });
                e.preventDefault();  // prevent the default zoom out action.
            }
        }
    }
};

class LineChart extends Component {

    componentDidMount() {

        let options = {
            labels: this.props.labels,
            legend: 'always',
            title: this.props.name,
            ylabel: '',
            strokeWidth: 1.5,
            rollPeriod: this.props.group,
            plugins: [
                doubleClickZoomOutPlugin
            ]
        };

        if (this.props.name === 'R_HUMIDITY')
            options['valueRange'] = [0, 100];
        else if (this.props.name === 'TEMPERATURE') {
            let min = _.min(this.props.batch.map(element => _.min(element.slice(1))));
            let max = _.max(this.props.batch.map(element => _.max(element.slice(1))));

            if (max - min < 50)
                options['valueRange'] = [-25 + (max + min) / 2, 25 + (max + min) / 2];
        } else if (this.props.name === 'PRESSURE') {
            let min = _.min(this.props.batch.map(element => _.min(element.slice(1))));
            let max = _.max(this.props.batch.map(element => _.max(element.slice(1))));

            if (max - min < 200)
                options['valueRange'] = [-100 + (max + min) / 2, 100 + (max + min) / 2];
        } else if (this.props.name.substring(0, 3) === 'PM_')
            options['valueRange'] = [0, 300];
        else
            options['valueRange'] = [0, 1000];

        let graph = new Dygraph(this.props.name,
            this.props.batch,
            options
            );

        this.props.handleSync(this.props.name, graph);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        let options = {
            labels: this.props.labels,
            legend: 'always',
            title: this.props.name,
            ylabel: '',
            strokeWidth: 1.5,
            rollPeriod: this.props.group,
            plugins: [
                doubleClickZoomOutPlugin
            ]
        };

        if (this.props.name === 'R_HUMIDITY')
            options['valueRange'] = [0, 100];
        else if (this.props.name === 'TEMPERATURE') {
            let min = _.min(this.props.batch.map(element => _.min(element.slice(1))));
            let max = _.max(this.props.batch.map(element => _.max(element.slice(1))));

            if (max - min < 50)
                options['valueRange'] = [-25 + (max + min) / 2, 25 + (max + min) / 2];
        } else if (this.props.name === 'PRESSURE') {
            let min = _.min(this.props.batch.map(element => _.min(element.slice(1))));
            let max = _.max(this.props.batch.map(element => _.max(element.slice(1))));

            if (max - min < 200)
                options['valueRange'] = [-100 + (max + min) / 2, 100 + (max + min) / 2];
        } else if (this.props.name.substring(0, 3) === 'PM_')
            options['valueRange'] = [0, 300];
        else
            options['valueRange'] = [0, 1000];

        if(this.props.batch !== prevProps.batch || this.props.group !== prevProps.group) {
            let graph = new Dygraph(this.props.name,
                this.props.batch,
                options
            );

            this.props.handleSync(this.props.name, graph);
        }
    }

    render() {
        return <div id={this.props.name} className={'graph_container'}>

        </div>
    }
}

export default LineChart;
//
// const {LineChart, Line, AreaChart, Area, Brush, XAxis, YAxis, CartesianGrid, Tooltip} = Recharts;
// const data = [
//     {name: 'Page A', uv: 4000, pv: 9000},
//     {name: 'Page B', uv: 3000, pv: 7222},
//     {name: 'Page C', uv: 2000, pv: 6222},
//     {name: 'Page D', uv: 1223, pv: 5400},
//     {name: 'Page E', uv: 1890, pv: 3200},
//     {name: 'Page F', uv: 2390, pv: 2500},
//     {name: 'Page G', uv: 3490, pv: 1209},
// ];
// const SimpleAreaChart = React.createClass({
//     render () {
//         return (
//             <div>
//                 <h4>A demo of synchronized AreaCharts</h4>
//                 <LineChart width={600} height={200} data={data} syncId="anyId"
//                            margin={{top: 10, right: 30, left: 0, bottom: 0}}>
//                     <CartesianGrid strokeDasharray="3 3"/>
//                     <XAxis dataKey="name"/>
//                     <YAxis/>
//                     <Tooltip/>
//                     <Line type='monotone' dataKey='uv' stroke='#8884d8' fill='#8884d8' />
//                 </LineChart>
//                 <p>Maybe some other content</p>
//                 <LineChart width={600} height={200} data={data} syncId="anyId"
//                            margin={{top: 10, right: 30, left: 0, bottom: 0}}>
//                     <CartesianGrid strokeDasharray="3 3"/>
//                     <XAxis dataKey="name"/>
//                     <YAxis/>
//                     <Tooltip/>
//                     <Line type='monotone' dataKey='pv' stroke='#82ca9d' fill='#82ca9d' />
//                     <Brush />
//                 </LineChart>
//                 <AreaChart width={600} height={200} data={data} syncId="anyId"
//                            margin={{top: 10, right: 30, left: 0, bottom: 0}}>
//                     <CartesianGrid strokeDasharray="3 3"/>
//                     <XAxis dataKey="name"/>
//                     <YAxis/>
//                     <Tooltip/>
//                     <Area type='monotone' dataKey='pv' stroke='#82ca9d' fill='#82ca9d' />
//                 </AreaChart>
//             </div>
//         );
//     }
// })
//
// ReactDOM.render(
//     <SimpleAreaChart />,
//     document.getElementById('container')
// );


// WEBPACK FOOTER //
// ./src/components/Chart/LineChart.js